import { useState, useCallback } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Breadcrumb from "@/components/base/Breadcrumb";
import { siteInfo } from "@/mocks/site";

const CONTACT_FORM_URL = "https://readdy.ai/api/form/d9s96u4nlsngrm4lmih0";

function BrandSection() {
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-foreground-900 mb-8" style={{ fontFamily: "var(--font-heading)" }}>
          品牌介绍
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 items-center">
          <div>
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20modern%20office%20workspace%20with%20beautiful%20Asian%20women%20team%20collaborating%20on%20fashion%20content%20creation%2C%20warm%20natural%20light%2C%20minimalist%20design%2C%20creative%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=about-brand&orientation=landscape"
              alt="美女网站精选推荐团队"
              className="w-full rounded-lg"
            />
          </div>
          <div>
            <p className="text-foreground-700 leading-relaxed mb-4">
              <strong className="text-foreground-900">美女网站精选推荐</strong>成立于{siteInfo.foundingYear}年，是国内领先的美女内容聚合平台。我们致力于为爱美人士提供最优质的视觉体验与时尚资讯。
            </p>
            <p className="text-foreground-700 leading-relaxed mb-4">
              我们的编辑团队由资深时尚编辑、专业摄影师和美妆达人组成，每日从全网精选高质量内容，涵盖美女写真、时尚穿搭、美妆教程、生活方式等多个领域。
            </p>
            <p className="text-foreground-700 leading-relaxed">
              我们秉持<strong className="text-foreground-900">"发现美、欣赏美、分享美"</strong>的理念，严格筛选每一条内容，确保为用户带来最优质的浏览体验。截至目前，平台已累计收录超过{siteInfo.stats.articles}篇精选内容，服务超过{siteInfo.stats.subscribers}用户。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

function StatsSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { value: siteInfo.stats.articles, label: "精选文章" },
            { value: siteInfo.stats.categories, label: "内容分类" },
            { value: siteInfo.stats.totalViews, label: "累计浏览量" },
            { value: siteInfo.stats.subscribers, label: "订阅用户" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary-500" style={{ fontFamily: "var(--font-heading)" }}>
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500 mt-2">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialsSection() {
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-foreground-900 mb-8" style={{ fontFamily: "var(--font-heading)" }}>
          用户口碑
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {siteInfo.testimonials.map((t, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, starIdx) => (
                  <i
                    key={starIdx}
                    className={`text-sm ${
                      starIdx < t.rating
                        ? "ri-star-fill text-accent-500"
                        : "ri-star-line text-foreground-300"
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                &ldquo;{t.content}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 text-sm font-medium">
                  {t.name[0]}
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">
                    {t.name}
                  </div>
                  <div className="text-xs text-foreground-400">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQSection() {
  return (
    <section id="faq" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-foreground-900 mb-8" style={{ fontFamily: "var(--font-heading)" }}>
          常见问题
        </h2>
        <div className="flex flex-col gap-3">
          {siteInfo.faqs.map((faq, i) => (
            <details
              key={i}
              className="group rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-sm font-medium text-foreground-900 list-none">
                {faq.question}
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

function ContactSection() {
  const [formState, setFormState] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      const form = e.currentTarget;
      const formData = new FormData(form);
      const honeypot = formData.get("phone_alt") as string;
      if (honeypot && honeypot.trim() !== "") {
        setFormState("success");
        return;
      }
      if (!CONTACT_FORM_URL) {
        setFormState("success");
        form.reset();
        return;
      }
      try {
        formData.delete("phone_alt");
        const searchParams = new URLSearchParams();
        formData.forEach((value, key) => {
          searchParams.append(key, value as string);
        });
        const response = await fetch(CONTACT_FORM_URL, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: searchParams.toString(),
        });
        const responseText = await response.text();
        let parsed;
        try {
          parsed = JSON.parse(responseText);
        } catch {
          parsed = null;
        }
        if (
          response.ok &&
          parsed &&
          parsed.code === "OK"
        ) {
          setFormState("success");
          form.reset();
        } else {
          const serverMsg =
            parsed?.meta?.message ||
            parsed?.message ||
            parsed?.meta?.detail ||
            responseText ||
            "提交失败";
          if (serverMsg.includes("spam")) {
            setFormError("提交失败，请稍后再试");
          } else {
            setFormError(serverMsg);
          }
          setFormState("error");
        }
      } catch {
        setFormError("网络错误，请检查连接后重试");
        setFormState("error");
      }
    },
    [],
  );

  return (
    <section id="contact" className="py-10 md:py-14">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-foreground-900 mb-8" style={{ fontFamily: "var(--font-heading)" }}>
          联系我们
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
          <div>
            <h3 className="text-lg font-semibold text-foreground-900 mb-4">联系方式</h3>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-mail-line"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">电子邮箱</div>
                  <div className="text-sm text-foreground-500">{siteInfo.email}</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-phone-line"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">联系电话</div>
                  <div className="text-sm text-foreground-500">{siteInfo.phone}</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-map-pin-line"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">公司地址</div>
                  <div className="text-sm text-foreground-500">{siteInfo.address}</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                  <i className="ri-wechat-line"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">微信公众号</div>
                  <div className="text-sm text-foreground-500">{siteInfo.social.wechat}</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            {formState === "success" ? (
              <div className="flex flex-col items-center justify-center h-full text-center py-10">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                  <i className="ri-check-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">提交成功！</h3>
                <p className="text-sm text-foreground-500">感谢您的留言，我们会尽快回复您。</p>
              </div>
            ) : (
              <form
                id="contact-form"
                data-readdy-form="true"
                onSubmit={handleSubmit}
                className="flex flex-col gap-4"
              >
                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    姓名
                  </label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-4 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    邮箱
                  </label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-4 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
                <div>
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    留言
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    rows={4}
                    required
                    maxLength={500}
                    className="w-full px-4 py-2.5 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                    placeholder="请输入您的留言内容（500字以内）"
                  ></textarea>
                </div>
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />
                {formState === "error" && (
                  <p className="text-sm text-red-500">{formError}</p>
                )}
                <button
                  type="submit"
                  className="w-full py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  提交留言
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default function AboutPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: `关于我们 - ${siteInfo.name}`,
            description: siteInfo.description,
            url: `${siteInfo.url}/about`,
            isPartOf: {
              "@type": "WebSite",
              name: siteInfo.name,
              url: siteInfo.url,
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: siteInfo.faqs.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.answer,
              },
            })),
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: "首页", path: "/" },
                { label: "关于我们" },
              ]}
            />
          </div>

          <div className="max-w-7xl mx-auto px-4 md:px-6 pt-6 pb-2">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 text-center" style={{ fontFamily: "var(--font-heading)" }}>
              关于我们
            </h1>
            <p className="text-center text-foreground-500 text-sm mt-2 max-w-2xl mx-auto">
              了解我们的品牌故事、团队理念与发展历程
            </p>
          </div>

          <BrandSection />
          <StatsSection />
          <TestimonialsSection />
          <FAQSection />
          <ContactSection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}